<template>
  <div ref="threeContainer" class="three-container"></div>
</template>

<script>
import * as THREE from 'three';

export default {
  mounted() {
    this.initScene();
  },
  methods: {
    initScene() {
      const container = this.$refs.threeContainer;
      const scene = new THREE.Scene();
      const camera = new THREE.PerspectiveCamera(75, 1440 / 250, 0.1, 1000);

      const renderer = new THREE.WebGLRenderer({ alpha: true });
      renderer.setSize(1440, 250);
      container.appendChild(renderer.domElement);

      const particleCount = 350;
      const spawnRate = 35.5;
      const moveSpeed = 0.5;

      const geometry = new THREE.BufferGeometry();
      const positions = new Float32Array(particleCount * 3);
      const velocities = new Float32Array(particleCount);

      for (let i = 0; i < particleCount; i++) {
        positions[i * 3] = (Math.random() * 2 - 1) * spawnRate;
        positions[i * 3 + 1] = (Math.random() * 2 - 1) * spawnRate;
        positions[i * 3 + 4] = (Math.random() * 2 - 1) * spawnRate;
        velocities[i] = (Math.random() * 0.01 + 0.01) * moveSpeed;
      }

      geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
      geometry.setAttribute('velocity', new THREE.BufferAttribute(velocities, 1));

      const material = new THREE.PointsMaterial({
        color: 0xff6600,
        size: 0.25,
        transparent: true,
        opacity: 0.6,
        depthWrite: false,
        blending: THREE.AdditiveBlending,
        map: this.createCircleTexture(),
      });

      const particles = new THREE.Points(geometry, material);
      scene.add(particles);
      camera.position.z = 8;

      const animate = () => {
        requestAnimationFrame(animate);
        const positions = particles.geometry.attributes.position.array;
        const velocities = particles.geometry.attributes.velocity.array;

        for (let i = 0; i < particleCount; i++) {
          positions[i * 3] += velocities[i];
          positions[i * 3 + 1] += (Math.random() * 0.02 - 0.01) * moveSpeed;

          if (positions[i * 3] > 2 * spawnRate) positions[i * 3] = -2 * spawnRate;
          if (positions[i * 3 + 1] > spawnRate || positions[i * 3 + 1] < -spawnRate) {
            positions[i * 3 + 1] = (Math.random() * 2 - 1) * spawnRate;
          }
        }
        particles.geometry.attributes.position.needsUpdate = true;
        renderer.render(scene, camera);
      };
      animate();
    },
    createCircleTexture() {
      const size = 100;
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');
      const gradient = ctx.createRadialGradient(size / 2, size / 2, 0, size / 2, size / 2, size / 2);
      gradient.addColorStop(0, 'rgba(255, 85, 0, 1)');
      gradient.addColorStop(1, 'rgba(255, 85, 0, 0)');
      ctx.fillStyle = gradient;
      ctx.beginPath();
      ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
      ctx.fill();
      return new THREE.CanvasTexture(canvas);
    },
  },
};
</script>

<style scoped>
.three-container {
  margin: 0;
  overflow: hidden;
  width: 1440px;
  height: 250px;
  position: absolute;
  top:35%; left: 12%;
}
.three-container{}
</style>



// WEBPACK FOOTER //
// src/components/ParticleSystem03.vue